function GuestPreferences() {
    return (
      <>
        <div className="font-bold text-lg mb-16">GuestPreferences</div>
      </>
    );
  }
  
  export default GuestPreferences;